var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper",attrs:{"fx":"","fxcenter":"","fxacenter":"","h-100":"","w-100":""}},[_c('PricingTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }